export default "__VITE_ASSET__zv9Yh8W9__"